module.exports = __webpack_public_path__ + "img/github.010cc352.svg";